/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubscriberRefund {
  amount?: number;
  authCode?: string;
  authorizationCode?: string;
  cancellationProtocol?: string;
  dateCreated?: Date;
  dateRefunded?: Date;
  editionId?: number;
  hasBeenApproved?: number;
  hasRefunded?: number;
  lastSubscriberBillingStatus?: number;
  message?: string;
  partialRefund?: number;
  paymentId?: number;
  paymentLogId?: number;
  paymentMethodId?: number;
  removeEdition?: number;
  subscriberBillingId?: number;
  subscriberId?: number;
  subscriberRenewalId?: number;
}
